// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";

// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import axios from "axios";

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider, Store } from "./app/themeContext";
import Background from "./app/background";
//import Toggle from "./app/themeToggle";
import reportWebVitals from "./reportWebVitals";
//import * as serviceWorker from "./registerServiceWorker";
//import "./i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <Background>
          <Store>
            <main>
              {/* <div className="absolute left-0 top-0 mr-2 mt-2 md:mr-2 md:mt-2">
           
              </div> */}
              <App />
            </main>
          </Store>
        </Background>
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//serviceWorker.register();
